import { FileOutput, RotateCwSquare, Trash2, X } from "lucide-react";
import { motion } from "motion/react";
import { FormattedMessage } from "react-intl";

import { Button } from "~/components/ui/button";

interface FloatingActionBarProps {
  selectedCount: number;
  onExtract: () => void;
  onRotate: () => void;
  onDelete: () => void;
  onClose: () => void;
  isExtractPending?: boolean;
  isRotatePending?: boolean;
  isDeletePending?: boolean;
}

export const FloatingActionBar = ({
  selectedCount,
  onExtract,
  onRotate,
  onDelete,
  onClose,
  isExtractPending = false,
  isRotatePending = false,
  isDeletePending = false,
}: FloatingActionBarProps) => {
  const isAnyPending = isExtractPending || isRotatePending || isDeletePending;

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        transition: { duration: 0.2, ease: "easeOut" },
      }}
      exit={{
        y: 20,
        opacity: 0,
        transition: { duration: 0.15, ease: "easeIn" },
      }}
      className="absolute bottom-3 left-3 right-3 z-20 flex items-center justify-between bg-blue-600 rounded-lg shadow-[0_-4px_20px_rgba(59,130,246,0.3)] px-4 pr-2 py-2"
    >
      <span className="text-sm text-white font-normal whitespace-nowrap">
        <FormattedMessage
          id="docList.multiSelect.selected"
          defaultMessage="{count} selected"
          values={{ count: selectedCount }}
        />
      </span>

      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          className="bg-brand hover:bg-blue-700 border-blue-400 text-brand-foreground! h-8 px-3 text-sm"
          onClick={onExtract}
          disabled={isAnyPending}
        >
          <FileOutput className="h-4 w-4 mr-1" />
          <FormattedMessage
            id="docList.multiSelect.extract"
            defaultMessage="Extract"
          />
        </Button>

        <Button
          variant="outline"
          className="bg-brand hover:bg-blue-700 border-blue-400 text-brand-foreground! h-8 px-3 text-sm"
          onClick={onRotate}
          disabled={isAnyPending}
        >
          <RotateCwSquare className="h-4 w-4 mr-1" />
          <FormattedMessage
            id="docList.multiSelect.rotate"
            defaultMessage="Rotate"
          />
        </Button>

        <Button
          variant="outline"
          className="bg-brand hover:bg-blue-700 border-blue-400 text-brand-foreground! h-8 px-3 text-sm"
          onClick={onDelete}
          disabled={isAnyPending}
        >
          <Trash2 className="h-4 w-4 mr-1" />
          <FormattedMessage
            id="docList.multiSelect.delete"
            defaultMessage="Delete"
          />
        </Button>

        <Button
          variant="outline"
          size="icon"
          className="bg-brand hover:bg-blue-700 border-transparent text-brand-foreground! h-8 w-8"
          onClick={onClose}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </motion.div>
  );
};
